import React, { useState } from 'react';

const KakaoChat = () => {
  const [hovered, setHovered] = useState(false);

  return (
    <div style={{
      position: "fixed",
      bottom: "24px",
      right: "20px",
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-end",
      gap: "6px",
      zIndex: 9999,
    }}>
      {/* 파트너 배지 */}
      <div style={{
        background: "white",
        borderRadius: "10px",
        padding: "4px 12px",
        fontSize: "11px",
        fontWeight: 700,
        color: "#1d4ed8",
        boxShadow: "0 4px 16px rgba(0,0,0,0.12)",
        textAlign: "center",
        letterSpacing: "0.02em",
        whiteSpace: "nowrap",
      }}>
        Google 공식 파트너
      </div>

      {/* 카카오 버튼 */}
      <a
        href="http://pf.kakao.com/_jyebn/chat"
        target="_blank"
        rel="noopener noreferrer"
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          background: "#FEE500",
          color: "#000",
          padding: "10px 16px",
          borderRadius: "14px",
          fontWeight: 700,
          fontSize: "13px",
          textDecoration: "none",
          boxShadow: hovered
            ? "0 8px 24px rgba(254,229,0,0.6)"
            : "0 4px 16px rgba(254,229,0,0.45)",
          transform: hovered ? "translateY(-2px)" : "translateY(0)",
          transition: "transform 0.2s ease, box-shadow 0.2s ease",
          whiteSpace: "nowrap",
        }}
      >
        <img
          src="https://img.icons8.com/color/22/000000/kakaotalk.png"
          alt="카카오톡"
          style={{ display: "block" }}
        />
        카카오 문의하기
      </a>
    </div>
  );
};

export default KakaoChat;